module.exports = __webpack_public_path__ + "img/fyaXAnPV.5ddf941f.svg";